<template>
  <div class="textarea-wrap">
    <textarea class="textareabox" @input="onInput" :value="textvalue" :placeholder="placeholder"> </textarea>
    <div class="textarea-manage">
      <div class="textarea-count">
        <span class="textarea-count-current">{{ textLength }}</span
        >/{{ maxlength }}
      </div>
      <ul class="textarea-btngroup">
        <li class="leftbtn">
          <MusicCommentBtn :bgcolor="'bg-black200'" :fontcolor="'ft-black'" @click-btn="onClickNo">
            <template #btnname>취소</template>
          </MusicCommentBtn>
        </li>
        <li class="leftbtn">
          <MusicCommentBtn @click-btn="onClickYes">
            <template #btnname>{{ yesBtn }}</template>
          </MusicCommentBtn>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import MusicCommentBtn from '../BasicButton/MusicCommentBtn.vue';
export default {
  props: {
    maxlength: {
      type: Number,
      default: 50,
      required: false
    },
    placeholder: {
      type: String,
      default: `이 노래의 한줄평을 남겨보세요:)`,
      required: false
    },
    value: {
      type: String,
      default: null,
      required: false
    },
    yesBtn: {
      type: String,
      default: '수정',
      required: false
    }
  },
  emits: ['cancel-btn', 'confirm-btn'],
  components: {
    MusicCommentBtn
  },
  data() {
    return {
      textvalue: null
    };
  },
  mounted() {
    this.textvalue = this.value;
  },
  methods: {
    onClickNo() {
      this.$emit('cancel-btn');
    },
    onClickYes() {
      if (!this.textvalue) return;
      this.$emit('confirm-btn', this.textvalue);
    },
    onInput($event) {
      if ($event.target.value && $event.target.value.length > this.maxlength) {
        this.textvalue = $event.target.value.slice(0, this.maxlength);
        $event.target.value = this.textvalue;
        return;
      }
      this.textvalue = $event.target.value;
    }
  },
  computed: {
    textLength() {
      return this.textvalue ? this.textvalue.length : 0;
    }
  }
};
</script>
<style scoped src="@/assets/css/textarea/textarea.css"></style>
